import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';

import { CheckBoxModule } from '../../../check-box/check-box.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { RadioGroupModule } from '../../../radio-group/radio-group.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';

import { PrintMapFormComponent } from './print-map-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckBoxModule,
    InputBoxModule,
    RadioGroupModule,
    SelectBoxModule,
    BlockModalDragModule,
    ScrollViewModule,
  ],
  declarations: [PrintMapFormComponent],
  exports: [PrintMapFormComponent],
})
export class PrintMapFormModule {}
